<div class="label-with-icon">
  <mat-icon class="icon" [fontSet]="iconFontSet">{{ iconName }}</mat-icon>
  <div class="label"><ng-content></ng-content></div>
</div>
